function Currency(number){
	const newNumber = Number(number).toFixed(2).replace('.', ',');
	return newNumber.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
}
export default Currency;